export const GUESTAPP_API_BASE_URL = 'https://wire.guest-suite.com/rest'

export const WEBSITE_BASE_URL = `https://${process.env.NEXT_PUBLIC_VERCEL_URL}`
export const BASE_API_URL = `${WEBSITE_BASE_URL}/api`